import React, { useState, useMemo } from 'react';
import styles from './Features.module.css';
import Lightbox from './Lightbox';

/**
 * Секция «Множество занятий и развлечений» в стиле majestic-rp:
 *  - слева: большая карточка-слайдер с активностью
 *  - справа: видео-превью + сетка скриншотов
 *  - клик по любому изображению открывает Lightbox с прокруткой
 */
const SLIDES = [
  {
    title: 'Десятки режимов и активностей',
    text:
      'Выживание, мини-игры, ивенты, PvE-боссы, кланы и экономика — выбирай то, что тебе по душе. ' +
      'Каждый день в InterWorld происходит что-то новое.',
    image: '/screens/Hytale2026-04-21_00-05-37.png'
  },
  {
    title: 'Своё дело и экономика',
    text:
      'Развивай ферму, открывай магазин, торгуй с другими игроками. ' +
      'Внутренняя экономика построена так, чтобы и одиночка, и команда могли найти своё место.',
    image: '/screens/Hytale2026-04-16_22-27-19.png'
  },
  {
    title: 'Регулярные ивенты',
    text:
      'Праздничные события, турниры, конкурсы — администрация постоянно проводит активности с ' +
      'ценными внутриигровыми наградами.',
    image: '/screens/Hytale2026-04-10_03-42-56.png'
  }
];

const THUMBS = [
  '/screens/Hytale2026-02-20_00-46-36.png',
  '/screens/Hytale2026-03-15_22-43-14.png',
  '/screens/Hytale2026-03-15_23-27-25.png',
  '/screens/Hytale2026-03-22_23-13-40.png',
  '/screens/Hytale2026-03-29_23-12-11.png',
  '/screens/Hytale2026-04-05_22-32-36.png',
  '/screens/Hytale2026-04-14_21-19-25_1.png'
];

const Features = () => {
  const [idx, setIdx] = useState(0);
  const [lbIdx, setLbIdx] = useState(null);
  const slide = SLIDES[idx];

  // Общий список картинок для Lightbox: сначала слайды, потом миниатюры
  const gallery = useMemo(
    () => [...SLIDES.map((s) => s.image), ...THUMBS],
    []
  );

  const prev = () => setIdx((i) => (i - 1 + SLIDES.length) % SLIDES.length);
  const next = () => setIdx((i) => (i + 1) % SLIDES.length);

  const openLb = (i) => setLbIdx(i);
  const closeLb = () => setLbIdx(null);
  const lbPrev = () => setLbIdx((i) => (i - 1 + gallery.length) % gallery.length);
  const lbNext = () => setLbIdx((i) => (i + 1) % gallery.length);

  return (
    <section className={styles.features}>
      <div className={styles.wrap}>
        {/* Левая колонка — большой слайд */}
        <div className={styles.slideCol}>
          <div className={styles.slide}>
            <img
              src={slide.image}
              alt={slide.title}
              className={styles.slideImg}
              onClick={() => openLb(idx)}
              style={{ cursor: 'zoom-in' }}
            />
            <button
              type="button"
              className={`${styles.arrow} ${styles.arrowLeft}`}
              onClick={prev}
              aria-label="Предыдущий слайд"
            >
              ‹
            </button>
            <button
              type="button"
              className={`${styles.arrow} ${styles.arrowRight}`}
              onClick={next}
              aria-label="Следующий слайд"
            >
              ›
            </button>
          </div>
          <h2 className={styles.title}>{slide.title}</h2>
          <p className={styles.text}>{slide.text}</p>
        </div>

        {/* Правая колонка — превью и галерея */}
        <div className={styles.galleryCol}>
          <a
            href="https://www.youtube.com/watch?v=CKrMwrsJd2U"
            target="_blank"
            rel="noreferrer"
            className={styles.videoCard}
          >
            <img
              src="https://img.youtube.com/vi/CKrMwrsJd2U/maxresdefault.jpg"
              alt="Видео InterWorld"
              className={styles.videoImg}
              onError={(e) => { e.currentTarget.src = 'https://img.youtube.com/vi/CKrMwrsJd2U/hqdefault.jpg'; }}
            />
            <div className={styles.videoOverlay}>
              <span className={styles.playBtn} aria-hidden="true">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </span>
              <span className={styles.videoLabel}>
                Посмотри видео<br />с самым интересным
              </span>
            </div>
          </a>

          <div className={styles.thumbs}>
            {THUMBS.slice(0, 7).map((src, i) => (
              <button
                type="button"
                key={i}
                className={styles.thumb}
                onClick={() => openLb(SLIDES.length + i)}
                aria-label="Открыть скриншот"
              >
                <img src={src} alt="" />
              </button>
            ))}
            <button
              type="button"
              className={`${styles.thumb} ${styles.thumbMore}`}
              onClick={() => openLb(SLIDES.length)}
            >
              Больше<br />фото
              <span className={styles.moreArrow}>›</span>
            </button>
          </div>
        </div>
      </div>

      {lbIdx !== null && (
        <Lightbox
          images={gallery}
          index={lbIdx}
          onClose={closeLb}
          onPrev={lbPrev}
          onNext={lbNext}
        />
      )}
    </section>
  );
};

export default Features;
